<template>
  <div class="fullbox">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="fullbox_table fullbox_table1">
      <pcTable :tableData="tableSaleAll" :type="type" />
    </div>
  </div>
</template>

<script>
import apis from "@/apis/photoCasually";
import pcTable from "./tableDetail.vue";
import moment from "moment";
// import moment from "moment";
export default {
  name: "causallyPush",
  components: {
    pcTable,
  },
  data() {
    return {
      tableSaleAll: [],
      loading: false,
      type: "",
      time:''
    };
  },
  computed: {},
  mounted() {
    const { type,time } = this.$route.query;
    this.type = type;
    this.time = time
    this.getTableTypeAll();
    // this.loading = true;
    // setTimeout(() => {
    //   const userId = sessionStorage.getItem("userId");
    //   if (!userId) {
    //     let timer = null;
    //     timer = setInterval(() => {
    //       this.getTableTypeAll();
    //       this.getSelectShow()
    //       if (this.userId) {
    //         clearInterval(timer);
    //       }
    //     }, 500);
    //   } else {
    //     this.getTableTypeAll();
    //     this.getSelectShow()
    //   }
    // }, 700);
    // if (id) {
    //   this.urlId = id;
    //   this.getReadTask();
    // }

    // this.loading = true;
    // setTimeout(() => {
    //   this.token = sessionStorage.userAuth;
    //   this.getTableTypeAll();
    // }, 500);
  },
  methods: {
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 获取列表
    getTableTypeAll() {
      // 取当前月一号
      const startDate = moment(this.time).startOf("month").format("YYYY-MM-DD");
      // 取下个月一号
      const endDate = moment(this.time)
        .add(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
      let json = {
        page: 1,
        pageSize: 999,
        state: this.type == 1 ? '0' : this.type,
        empNo: "",
        disposeNo: "",
        startTime: startDate + ' ' + '00:00:00',
        endTime: endDate + ' ' + '00:00:00',
      };
      apis
        .adminList(json)
        .then((res) => {
          if (res.code == 200) {
            this.tableSaleAll = res.data.list;
            // this.tableSaleAll.length > 0 &&
            //   this.tableSaleAll.forEach((item) => {
            //     item.date = `${item.year}-${moment(item.month).format("MM")}`;
            //   });
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.fullbox {
  background: #fff;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  text-align: center;
  padding-bottom: 50px;
  position: relative;

  .goback {
    margin: 50px 40px 20px 30px;
    display: flex;
    align-items: center;

    div {
      display: flex;
      align-items: center;
      width: 100%;
    }

    i {
      font-weight: bold;
      font-size: 48px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
      margin-left: 30px;
      font-weight: bold;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .fullbox_top {
    font-size: 44px;
    padding: 100px 0 50px;
  }
  .fullbox_search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // justify-content: center;
    .data-switch {
      display: flex;
      .data-type {
        width: 175px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.19);
        font-size: 32px;
        font-weight: 400;
        line-height: 70px;
        text-align: center;
        color: #3d3d3d;
        cursor: pointer;

        &.monthly {
          border-radius: 36px 0 0 36px;
        }
        &.realtime {
          border-radius: 0 36px 36px 0;
          // margin-right: 10px;
        }

        &.active {
          font-weight: bold;
          background: #018755;
          box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.19);
          color: #fff;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .fullbox_table {
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5%;
    }
    .goback{
      margin-top: 50px;
      width: 90%;
      margin-left: 5%;
    }
    .fullbox_search {
      padding: 0 50px 0;
      // position: absolute;
      // top: 4.3%;
      // right: 2%;
      ::v-deep {
        .el-date-editor {
          height: 40px;
          width: 140px;
        }
        .el-input__inner {
          height: 40px;
          width: 140px;
        }
      }
    }
    .fullbox_time {
      font-size: 36px;
      // margin-right: 100px;
    }
  }
  @media screen and (min-width: 600px) {
    .fullbox_table {
      width: 70%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 50px;
      margin-left: 15%;
    }
    .goback{
      margin-top: 50px;
      width: 70%;
      margin-left: 15%;
    }
    .fullbox_table2 {
      width: 90%;
      margin-left: 5%;
    }
    .fullbox_search {
      padding: 0 15% 0;
      // position: absolute;
      // top: 3%;
      // right: 25%;
      ::v-deep {
        .el-date-editor {
          height: 40px;
          width: 140px;
        }
        .el-input__inner {
          height: 40px;
          width: 140px;
        }
      }
    }
  }
  // .fullbox_table {
  //   width: 100%;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   margin-top: 30px;
  //   // margin-left: 25%;
  // }
  ::v-deep {
    .fullbox_table1 {
      .el-table {
        font-size: 17px;
        .cell {
          color: #000;
        }
      }
    }
  }
}
</style>
